import { BadgeProps } from "@oysterhr/ui"

import { TrustLevelEnum } from "@oysterhr/schema"

type trustLevelType = {
  variation: BadgeProps["variation"]
  titleKey: string
}

export const TRUST_LEVELS: { [key in TrustLevelEnum]: trustLevelType } = {
  [TrustLevelEnum.Excellent]: {
    variation: "success",
    titleKey: "excellent",
  },
  [TrustLevelEnum.Good]: {
    variation: "success",
    titleKey: "good",
  },
  [TrustLevelEnum.Fair]: {
    variation: "warning",
    titleKey: "fair",
  },
  [TrustLevelEnum.None]: {
    variation: "gray",
    titleKey: "none",
  },
  [TrustLevelEnum.AiGenerated]: {
    variation: "gray",
    titleKey: "aiGenerated",
  },
}
